import CURRENCIES from './currencies.js';

var symbol = function symbol(currencyCode) {
  if (currencyCode === void 0) {
    currencyCode = 'USD';
  }
  try {
    var _currencyCode;
    currencyCode = ((_currencyCode = currencyCode) !== null && _currencyCode !== void 0 ? _currencyCode : 'USD').toLocaleUpperCase();
  } catch (error) {
    console.error('Error with converting currency code', error);
    currencyCode = 'USD';
  }
  if (!CURRENCIES[currencyCode]) {
    currencyCode = 'USD';
  }
  return CURRENCIES[currencyCode].symbol_native;
};

export { symbol as default };
//# sourceMappingURL=symbol.js.map
